import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button, Text, Flex } from '../Base';

const ButtonStyle = styled(Button)`
  justify-content: center;
  align-items: center;
`;

const ButtonIcon = ({ leftIcon, message, rightIcon, textProp, ...props }) => (
  <ButtonStyle display={'flex'} {...props}>
    {leftIcon && <Flex mr={2}>{leftIcon}</Flex>}
    <Text {...textProp}>{message}</Text>
    {rightIcon && <Flex ml={2}>{rightIcon}</Flex>}
  </ButtonStyle>
);

ButtonIcon.propTypes = {
  leftIcon: PropTypes.element,
  message: PropTypes.string,
  rightIcon: PropTypes.element,
};

export default ButtonIcon;
